export default {
  SEARCH_CATALOG_ALLIANZ_OCCUPATION_QUERY: Symbol.for('SEARCH_CATALOG_ALLIANZ_OCCUPATION_QUERY'),
  CATALOG_ALLIANZ_OCCUPATION_REPOSITORY: Symbol.for('CATALOG_ALLIANZ_OCCUPATION_REPOSITORY'),
  CATALOG_ALLIANZ_OCCUPATION_STATE_MANAGER: Symbol.for('CATALOG_ALLIANZ_OCCUPATION_STATE_MANAGER'),
};
